<template>
  <div>
    <el-radio-group v-model="dateTypeVal" size="small" @change="handleTypeChange">
      <el-radio-button label="date">日</el-radio-button>
      <el-radio-button label="month">月</el-radio-button>
      <el-radio-button label="year">年</el-radio-button>
    </el-radio-group>
    <el-date-picker
      v-model="value"
      :type="picType"
      size="small"
      style="width: 150px;margin-left:10px;"
      :placeholder="placeholder"
      @change="handleChange"
      :clearable="false"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
    ></el-date-picker>
    <!-- format="yyyy-MM-dd HH:mm:ss"
    value-format="yyyy-MM-dd HH:mm:ss"-->
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "date" //可以是'year','month','date'等
    },
    dateType: {
      type: String,
      default: "date"
    }
  },
  data() {
    return {
      value: "", //绑定值
      valueData: [],
      dateTypeVal: this.dateType, //年月日切换
      picType: this.type,
      placeholder: "日期选择",
      startDate: "",
      endDate: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //禁用未来的日期
        }
      }
    };
  },
  created() {
    this.handleTypeChange();
  },
  mounted() {},
  methods: {
    handleChange(value) {
      if (value) {
        this.value = value;
        if (this.picType == "date") {
          const start = `${value} 00:00:00`;
          const end = `${value} 23:59:59`;
          this.valueData = [start, end];
        } else if (this.picType == "month") {
          const year = parseInt(value.split("-")[0], 10);
          const month = parseInt(value.split("-")[1], 10);
          const lastDayOfMonth = new Date(year, month, 0).getDate(); //获取该月最后一天
          const formattedEndDate = `${year}-${String(month).padStart(
            2,
            "0"
          )}-${String(lastDayOfMonth).padStart(2, "0")} 23:59:59`;
          const formattedStartDate = `${value.slice(0, 7)}-01 00:00:00`;
          this.valueData = [formattedStartDate, formattedEndDate];
        } else if (this.picType == "year") {
          const yearStart = `${value.slice(0, 4)}-01-01 00:00:00`;
          const yaerEnd = `${value.slice(0, 4)}-12-31 23:59:59`;
          this.valueData = [yearStart, yaerEnd];
        }
        this.startDate = this.valueData[0];
        this.endDate = this.valueData[1];
      } else {
        this.value = "";
        this.valueData = [];
      }
      console.log("value", this.value);
      this.$emit("change-picker", this.startDate, this.endDate, this.picType); //触发change事件，传递选中的值
    },
    handleTypeChange() {
      this.picType = this.dateTypeVal;
      const datas = new Date().toISOString().split("T")[0];
      if (this.dateTypeVal == "date") {
        this.placeholder = "日期选择";
        this.value = datas; //设置当前日期为默认值
      } else if (this.dateTypeVal == "month") {
        this.placeholder = "月份选择";
        this.value = datas.slice(0, 7); //当前月份
      } else if (this.dateTypeVal == "year") {
        this.placeholder = "年份选择";
        this.value = datas.slice(0, 4); //当年
      }
      this.handleChange(datas);
      console.log("type", this.dateTypeVal, this.picType);
    }
  }
};
</script>

<style scoped lang="less">
</style>
